import { currentEnv } from "./env";

const DESCOPE_PROJECT_IDS = {
  dev: "P2voq4YYKuWL2vnAsDb5WFL6ABwX",
  prod: "P2uauJRWGAdv36GrgQdpnyoo54Dy",
  staging: "P2u3a2sCV3qh0kUhrfUDUBA9RCNZ",
  get testing() {
    return this.staging;
  },
} as const;

function getDescopeConfig() {
  return {
    inviteUserFlowId: "custom-invite-teammates",
    projectId: DESCOPE_PROJECT_IDS[currentEnv],
    redirectUrl: "/login",
    signInFlowId: "custom-sign-in",
  };
}

export const descopeConfig = getDescopeConfig();
